<template>
  <div class="page-content">
    <h1 class="page-title">{{ $locale("mail.list.title") }}</h1>
    <searchCom ref="searchComRef" @filter="filter_fn" @create="create_fn" />
    <!-- Table -->
    <el-table
      :data="tableData"
      class="egl-table list-table"
      stripe
      @sort-change="sortChange_fn"
      @filter-change="filterChange_fn"
    >
      <el-table-column
        column-key="category"
        :label="$locale('cinemaWebsite.news.table.header.category')"
        prop="category"
        align="center"
        width="150"
        :formatter="(row, column, cellValue) => { return categoryMapping[cellValue]}"
        :filters="filters.categoryList"
        :filtered-value="filters.categoryValues"
      ></el-table-column>
      <el-table-column
        :label="$locale('cinemaWebsite.news.table.header.title')"
        prop="title"
        sortable="custom"
        align="center"
        width="200"
      ></el-table-column>
      <el-table-column
        :label="$locale('mail.list.open')"
        align="center"
        width="160"
        column-key="publicType"
        :filters="filters.publishList"
        :filtered-value="filters.publishValues"
      >
        <template slot-scope="scope">
          <i
            class="status-btn"
            :class="publishMapping[scope.row.publicType].className"
          ></i>
          {{ publishMapping[scope.row.publicType].content }}
          <p v-if="scope.row.publicType === 'schedule' && $safeFormatDate(scope.row.publicTime, { format: 'YYYY-MM-DD HH:mm'})">{{ $safeFormatDate(scope.row.publicTime, { format: 'YYYY-MM-DD HH:mm'}) }}</p>
        </template>
      </el-table-column>
      <el-table-column
        :label="$locale('mail.list.publishLocation')"
        prop="publicTarget"
        align="center"
        width="200"
        column-key="publicTarget"
        :filters="filters.publicTargetList"
        :filtered-value="filters.publicTargetValues"
        :formatter="(row, column, cellValue) => { 
          return $safeJoin(cellValue, '、', publicTargetMapping)
          }"
      ></el-table-column>
      <el-table-column
        :label="$locale('mail.list.publishTarget')"
        prop="scopeDescript"
        align="center"
        width="200"
        column-key="scope"
        :filters="[{
          text: 'すべてを選択',
          value: 'all'
        }, ...filters.scopeList]"
        :filtered-value="filters.scopeIds"
        :formatter="(row, column, cellValue) => { 
          return $safeJoin(cellValue, '、', [], '全員')
          }"
      ></el-table-column>
      <el-table-column
        :label="$locale('mail.list.publishDate')"
        prop="publicTime"
        sortable="custom"
        :formatter="(row, column, cellValue) => {
          return row.publicType === 'draft' ? '' : $safeFormatDate(cellValue, { format: 'YYYY-MM-DD HH:mm' })
          }"
        align="center"
      ></el-table-column>
      <el-table-column
        :label="$locale('mail.list.lastUpdate')"
        prop="lastUpdateTime"
        sortable="custom"
        :formatter="(row, column, cellValue) => { 
          return $safeFormatDate(cellValue, { format: 'YYYY-MM-DD HH:mm' })
          }"
        align="center"
      ></el-table-column>
      <el-table-column align="center" width="160">
        <template slot-scope="scope">
          <div class="handle">
            <a @click="changeHP(scope.row.id, scope.row.publicType)">{{ scope.row.publicType !== 'draft' ? $locale("cinemaWebsite.news.table.header.noHP") :
           $locale("cinemaWebsite.news.table.header.show") }}</a>
            <el-divider direction="vertical"></el-divider>
            <a @click="showDetail(scope.row.id)">{{ $locale("global.edit") }}</a>
            <el-divider direction="vertical"></el-divider>
            <a @click="delete_fn(scope.row.id, scope.row.title)">{{ $locale("global.delete") }}</a>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <CommPagination
      v-show="pageCount > 10"
      :total="pageCount"
      :curPage="page"
      :pageSize="pageSize"
      @current-change="choosePage"
    />
    <hr style="border: 0.5px solid #DDD;margin-bottom: 30px;" />
    <!-- <div style="display: flex;justify-content: center;align-items: center;">
      <span style="margin-right: 31px;">{{ `選択数 : ${selectNum}件` }}</span>
      <el-button class="egl-btn-yellow" @click="sendMailSelect">{{ $locale("mail.list.selectTitle") }}</el-button>
    </div> -->
  </div>
</template>
<script>
import CommPagination from "@/components/common/CommPagination";
import searchCom from './searchCom/index.vue'

import { categoryMapping } from "@/utils/common";
import { publishMapping, publicTargetMapping } from './script/index';
import countDownAlert from "@/utils/countDownAlert";

import { getNewsListService, updateStatusService, deleteNewsService, getmailingOptionListService } from "@/helpers/service/api/mailMagazine";

export default {
  data() {
    return {
      categoryMapping,
      publishMapping,
      publicTargetMapping,
      tableData: [],
      page: 0,
      pageSize: 10,
      pageCount: 1,
      filters: {
        categoryList: Object.entries(categoryMapping).map(([key, value]) => ({
          text: value,
          value: key
        })),
        categoryValues: Object.entries(categoryMapping).map(([key, value]) => ({
          text: value,
          value: key
        })).map((item) => item.value),
        publishList: Object.entries(publishMapping).map(([key, value]) => ({
          value: key,
          text: value.content
        })),
        publishValues: Object.entries(publishMapping).map(([key, value]) => ({
          value: key,
          text: value.content
        })).map((item) => item.value),
        publicTargetList: Object.entries(publicTargetMapping).map(([key, value]) => ({
          value: key,
          text: value
        })),
        publicTargetValues: Object.entries(publicTargetMapping).map(([key, value]) => ({
          value: key,
          text: value
        })).map((item) => item.value),
        scopeList: [],
        scopeIds: ['all'],
      },
      filterObj: {},
      sortKey: "",
      sortType: "",
      filterObj: {
        key: "",
        value: [],
      }
      // selectNum: 0,
    }
  },
  created() {
    getmailingOptionListService({ brandId: window.localStorage.getItem("brandId"), page: 0, pageSize: 10 }).then((res) => {
      if (res.data && res.data.length > 0) {
        res.data.forEach((item) => {
          this.filters.scopeList.push({
            text: item.name,
            value: item.id
          })
          this.filters.scopeIds.push(item.id);
        })
      }
    })
    getNewsListService({
        brandId: window.localStorage.getItem("brandId"),
      }).then((res) => {
        console.log(res.data.data);
        if (res.data && res.data.data && res.data.data.length > 0) {
          this.pageCount = res.data.count;
          this.tableData = res.data.data;
        } else {
          this.tableData = [];
        }
      })
  },
  methods: {
    filter_fn(onSearch = {}, page = 0) {
      const sortType = {
        descending: "DESC",
        ascending: "ASC"
      };
      getNewsListService({
        brandId: window.localStorage.getItem("brandId"),
        ...onSearch,
        ...this.sortKey ? { sortKey: this.sortKey } : {},
        ...this.sortType ? { sortType: sortType[this.sortType] } : {},
        ...this.filterObj.key ? {
          [this.filterObj.key] : this.filterObj.value,
        } : {},
        page,
        pageSize: 10,
      }).then((res) => {
        this.pageCount = res.data.count;
        if (res.data && res.data.data && res.data.data.length > 0) {
          this.tableData = res.data.data;
        } else {
          this.tableData = [];
        }
        this.$nextTick(() => {
          this.page = page;
        })
      })
    },
    changeHP(id, publicType) {
      const str = publicType === "public" ? "非公開" : "公開"
      let confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${str}設定になっているのでしょうか？</span>`;

      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.approve"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      })
        .then(() => {
          const cinemaId = window.localStorage.getItem("cinemaId");
          const brandId = window.localStorage.getItem("brandId");
          updateStatusService({ id }).then(() => {
            this.filter_fn(this.$refs.searchComRef.searchObj, this.page);
          })
        });
    },
    showDetail(id) {
      this.$router.push(`/mail-magazine/update/${id}`);
    },
    delete_fn(id, name) {
      let confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.delete")} ${name}</span>`;
      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.delete"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      })
        .then(() => {
          deleteNewsService({ id }).then(res => {
            if (!res.success) { return; }
            countDownAlert({
              content: this.$locale("global.deleteSuccessfully"),
              callback: () => {
                this.filter_fn(this.$refs.searchComRef.searchObj, this.page);
              }
            });
          });
        });
    },
    sendMailSelect() {
      this.$router.push("/mail-magazine/send");
    },
    create_fn() {
      this.$router.push("/mail-magazine/create");
    },
    choosePage(page) {
      this.page = page - 1;
      this.filter_fn(this.$refs.searchComRef.searchObj, this.page);
    },
    sortChange_fn({ column, prop, order}) {
      this.sortKey = !order ? "" : prop;
      this.sortType = order;
      this.filter_fn(this.$refs.searchComRef.searchObj);
    },
    filterChange_fn(filters) {
      const key = Object.keys(filters)[0];
      const value = filters[key];
      // if (value.includes('all')) {
      //   this.filterObj = {};
      // } else {
      //   this.filterObj = {
      //   key,
      //   value,
      // }
      this.filterObj = value.includes("all") ? {} : {
        key,
        value,
      };
      this.filter_fn(this.$refs.searchComRef.searchObj);
    }
  },
  components: {
    CommPagination,
    searchCom,
  },
}
</script>